import { useSuspenseFeatureGate } from 'FrontRoyalStatsig';

export function useStudentDashboardVersion() {
    const passesV2Gate = useSuspenseFeatureGate('student_dashboard_v2');
    return passesV2Gate ? 2 : 1;
}
